import { wsService } from "./wsService";

const section = "employees";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function filter_users(param = { enable: true }) {
  return wsService.make_post_request(section + "/filter-users", param);
}



function getActiveOperatorsWithTasks(param = {}) {
  return wsService.make_post_request(section + "/active-operators-with-tasks", param);
}

export const employeeService = {
  section,
  filter,
  remove,
  create,
  update,
  filter_users,
  getActiveOperatorsWithTasks,
};
